import axios from "axios";

export const state = {
    reportshareperusers: [],
};

export const getters = {
    reportshareperusers: state => state.reportshareperusers,
};

export const mutations = {
    setReportSharesPerUser(reportshareperusers, newValue) { state.reportshareperusers = newValue},
};

export const actions = {
    async fetchReportSharesPerUser({ commit }) {
        await axios.get('/reportsharesperusers').then(res => {
            commit('setReportSharesPerUser', res.data.shares)
        })
    },
    async filterReportSharesPerUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportsharesperusers";
        await axios.post(url, formData).then((response) => {
            commit('setReportSharesPerUser', response.data.shares)
        })
    },
};
